export{Accordion,AccordionDetail,AccordionHeader,AccordionItem,AccordionSubTitle,AccordionTitle}from"@vds-core/accordions";
